module.exports = __webpack_public_path__ + "static/media/quadrant-crypto-enthusiasts-non-devs.9638b650.svg";